import { getCategoryCatalog } from '../catalog/categories';

function copyValue(v) {
  if (Array.isArray(v)) return [...v];
  if (v && typeof v === 'object') return { ...v };
  return v;
}

export function mergeAttributes(...chunks) {
  return chunks.reduce((acc, chunk) => {
    if (!chunk) return acc;
    Object.entries(chunk).forEach(([k, v]) => {
      if (v !== undefined) acc[k] = copyValue(v);
    });
    return acc;
  }, {});
}

export function resolveAttributesTree(source) {
  if (!source || source.kind !== 'parametric-v2') return source;
  const catalog = getCategoryCatalog(source.category);
  const inheritable = new Set(catalog?.attributes?.inheritable || []);
  const parts = source.parts || [];
  const byId = new Map(parts.map((p) => [p.id, p]));

  const resolvePart = (part, cache = new Map()) => {
    if (cache.has(part.id)) return cache.get(part.id);
    const parent = part.parentId ? byId.get(part.parentId) : null;
    const parentResolved = parent ? resolvePart(parent, cache) : null;
    const inheritedFromParent = {};
    if (parentResolved?.effectiveAttributes) {
      inheritable.forEach((key) => {
        if (parentResolved.effectiveAttributes[key] !== undefined && part.attributes?.[key] === undefined) {
          inheritedFromParent[key] = copyValue(parentResolved.effectiveAttributes[key]);
        }
      });
    } else {
      inheritable.forEach((key) => {
        if (source.attributes?.[key] !== undefined && part.attributes?.[key] === undefined) {
          inheritedFromParent[key] = copyValue(source.attributes[key]);
        }
      });
    }
    const effectiveAttributes = mergeAttributes(source.attributes, inheritedFromParent, part.attributes);
    const resolved = { ...part, effectiveAttributes };
    cache.set(part.id, resolved);
    return resolved;
  };

  const cache = new Map();
  return { ...source, parts: parts.map((p) => resolvePart(p, cache)) };
}
